import { render, staticRenderFns } from "./ViewProjects.vue?vue&type=template&id=5953e6b4&scoped=true"
import script from "./ViewProjects.vue?vue&type=script&lang=js"
export * from "./ViewProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953e6b4",
  null
  
)

export default component.exports